import type { User } from 'types'
import api from 'lib/api'

export type UpdatePasswordInput = {
  newPassword: string
  confirmNewPassword: string
}

export function updatePassword(data: UpdatePasswordInput) {
  return api
    .put<{ data: User }>(`/api/v2/users/me/password`, { data })
    .then(({ data }) => data.data)
}
